import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { BlockedKeywords } from '../../types/blocked-keywords';
import { createBlockedKeywords, updateBlockedKeywords } from '../../api/blockedKeywordsApi';

interface AddEditBlockedKeywordsModalProps {
    blockedKeywords: BlockedKeywords | null;
    isOpen: boolean;
    toggle: () => void;
    onAddData: (newData: BlockedKeywords) => void;
    onUpdateData: (newData: BlockedKeywords) => void;
}

const AddEditBlockedKeywordsModal = ({ blockedKeywords, isOpen, toggle, onAddData, onUpdateData }: AddEditBlockedKeywordsModalProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const toggleAddModal = () => {
        toggle();
    };

    const validationSchema = Yup.object({
        name: Yup.string()
            .trim()
            .required('Nome é obrigatório'),
        words: Yup.string()
            .trim()
            .required('Lista de palavras chaves é obrigatório'),
    });

    const handleSubmit = (values: any) => {
        setLoading(true);
        if (values.id) {
            updateBlockedKeywords(values)
                .then((res: any) => {
                    toggleAddModal();
                    onUpdateData(res);
                    toast.success('Lista de palavras chave atualizada com sucesso!');
                })
                .catch(() => {})
                .finally(() => {
                    setLoading(false);
                });
        } else {
            createBlockedKeywords(values)
                .then((res: any) => {
                    toggleAddModal();
                    onAddData(res);
                    toast.success('Lista de palavras chave cadastrada com sucesso!');
                })
                .catch(() => {})
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <div className={`modal ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }} tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <Formik
                        initialValues={{
                            id: blockedKeywords?.id || undefined,
                            name: blockedKeywords?.name || '',
                            words: blockedKeywords?.words || '',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        enableReinitialize
                    >
                        {({ handleSubmit }) => (
                            <Form onSubmit={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSubmit();
                                return false;
                            }}>
                                <div className="modal-header bg-light p-3">
                                    <h5 className="modal-title">
                                        {blockedKeywords ? 'Editar' : 'Adicionar'} lista de palavras chave
                                    </h5>
                                    <button type="button" className="btn-close" onClick={toggleAddModal}></button>
                                </div>

                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Nome</label>
                                        <Field
                                            className="form-control"
                                            type="text"
                                            id="name"
                                            name="name"
                                        />
                                        <ErrorMessage name="name" component="div" className="invalid-feedback" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="words" className="form-label">Palavras chaves</label>
                                        <Field
                                            className="form-control"
                                            as="textarea"
                                            id="words"
                                            name="words"
                                            rows={10}
                                        />
                                        <ErrorMessage name="words" component="div" className="invalid-feedback" />
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-success btn-label right ms-auto nexttab nexttab">
                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                        {loading && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                                        { blockedKeywords ? 'Editar' : 'Cadastrar' }
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};

export default AddEditBlockedKeywordsModal;